<template>
    <div>
        <div class="paragraph">
            <div v-if="currentPage == 1">
                <p class="indent">由环境污染引起的温室效应是指地球表面变热的现象。</p>
                <p class="indent">温室效应主要是由于现代化工业社会过多燃烧煤炭、石油和天然气，这些燃料燃烧后放出大量的二氧化碳气体进入大气造成的。二氧化碳气体具有吸热和隔热的功能。它在大气中增多的结果是形成一种无形的玻璃罩，使太阳辐射到地球上的热量无法向外层空间发散，其结果是地球表面变热起来。因此，二氧化碳也被称为温室气体。</p>
                <p class="indent">温室气体有效地吸收地球表面、大气本身相同气体和云所发射出的红外辐射。大气辐射向所有方向发射，包括向下方的地球表面的放射。温室气体则将热量捕获于地面- - 对流层系统之内。这被称为“自然温室效应”。大气辐射与其气体排放的温度水平强烈耦合。在对流层中，温度一般随高度的增加而降低。从某一高度射向空间的红外辐射一般产生于平均温度在-19℃的高度，并通过太阳辐射的收入来平衡，从而使地球表面的温度能保持在平均1 4 ℃。温室气体浓度的增加导致大气对红外辐射不透明性能力的增强，从而引起由温度较低、高度较高处向空间发射有效辐射。这就造成了一种辐射强迫，这种不平衡只能通过地面 对流层系统温度的升高来补偿。这就是“增强的温室效应”。如果大气不存在这种效应，那么地表温度将会下降约3度或更多。反之，若温室效应不断加强，全球温度也必将逐年持续升高。</p>
                <p class="bold">由来</p>
                <p class="indent">温室效应主要是由于现代化工业社会过多燃烧煤炭、石油和天然气，大量排放尾气，这些燃料燃烧后放出大量的二氧化碳气体进入大气造成的。</p>
                <p class="indent">二氧化碳气体具有吸热和隔热的功能。它在大气中增多的结果是形成一种无形的玻璃罩，使太阳辐射到地球上的热量无法向外层空间发散，其结果是地球表面变热起来。因此，二氧化碳也被称为温室气体。</p>
            </div>
            <div v-if="currentPage == 2">
                <p class="indent">人类活动和大自然还排放其他温室气体，它们是：氯氟烃（CFC〕、甲烷、低空臭氧、和氮氧化物气体、地球上可以吸收大量二氧化碳的是海洋中的浮游生物和陆地上的森林，尤其是热带雨林。</p>
                <p class="indent">为减少大气中过多的二氧化碳，一方面需要人们尽量节约用电（因为发电烧煤〕，少开汽车。另一方面保护好森林和海洋，比如不乱砍滥伐森林，不让海洋受到污染以保护浮游生物的生存。我们还可以通过植树造林，减少使用一次性方便木筷，节约纸张（造纸用木材〕，不践踏草坪等等行动来保护绿色植物，使它们多吸收二氧化碳来帮助减缓温室效应</p>
                <p class="bold">特点</p>
                <p class="indent">温室有两个特点：温度较室外高，不散热。 生活中我们可以见到的玻璃育花房和蔬菜大棚就是典型的温室。使用玻璃或透明塑料薄膜来做温室，是让太阳光能够直接照射进温室，加热室内空气，而玻璃或透明塑料薄膜又可以不让室内的热空气向外散发，使室内的温度保持高于外界的状态，以提供有利于植物快速生长的条件。</p>
            </div>
        </div>
        <div class="link-content">
            <div class="bottom">
                <img src="../../../assets/images/shipin.jpg" /> <a href="javascript:void(0)" @click="back">视频版</a>
                <span class="margin-left">页码: </span> <span :class="{ active: currentPage == 1 }" class="page" @click="currentPage = 1">1</span> - <span :class="{ active: currentPage == 2 }" class="page" @click="currentPage = 2">2</span>
            </div>
            <div class="clear"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TextView",
        data() {
            return {
                currentPage: 1
            }
        },
        methods: {
            back() {
                this.$emit('onIndexChanged',1);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .link-content {
        margin-top: 2%;
        margin-left: 10%;
        width: 80%;
        .bottom {
            float: left;
            width: 100%;
            height: 80px;
            img {
                width: 50px;
                height: 50px;
            }
            .margin-left {
                margin-left: 40%;
            }
            a, span {
                font-size: 15px;
                color: #008000;
                text-decoration: none;
                cursor: pointer;
            }
            .page {
                padding: 3px 8px;
                border: 1px #aaa solid;
                background: #eee;
                box-shadow: -1px -1px 2px #ccc inset;
                font-weight: bold;
                &.active {
                    background: #4a97d4;
                    border: 1px #175187 solid;
                    color: #fff;
                    box-shadow: -1px -1px 2px #7894bd inset;
                }
            }
        }

    }
</style>